module.exports = __webpack_public_path__ + "static/media/referralOff_326.a75e3cb6.png";